import type { ReactNode } from 'react';
import type { HTMLMotionProps } from 'framer-motion';
import type { Theme, SxProps } from '@mui/material/styles';

import { m } from 'framer-motion';

import Box from '@mui/material/Box';

import { varContainer } from './variants';

// ----------------------------------------------------------------------

/**
 * 자식 `m.*` 들을 차례로 띄우는 껍데기. `varContainer()` 를 물려 준다.
 *
 * ⚠️ **필수 프롭이 없다.** 소비처는 `<Container component={MotionContainer}>` 처럼
 * 다른 부품의 `component` 로 얹어 쓴다(error 화면 셋 · expired · unsubscribe).
 *
 * ⚠️ `action` 이 참일 때만 `animate` 를 본다 — 거짓이면 `initial={false}` 로 시작해
 * 언제나 `'animate'` 로 간다. 그래서 이 부품의 `animate` 는 framer 의 `animate`(정의)가
 * 아니라 **불리언**이다.
 *
 * ⚠️ 나머지 프롭은 `Box component={m.div}` 로 그대로 간다.
 */
export type MotionContainerProps = Omit<HTMLMotionProps<'div'>, 'animate' | 'children'> & {
  sx?: SxProps<Theme>;
  children?: ReactNode;
  /** `action` 이 참일 때 `'animate'`(참) · `'exit'`(거짓) 중 무엇으로 갈지 */
  animate?: boolean;
  /** 참이면 초기 진입 애니메이션을 끄고 `animate` 가 갈래를 정한다. 기본 `false` */
  action?: boolean;
};

export function MotionContainer({
  sx,
  animate,
  children,
  action = false,
  ...other
}: MotionContainerProps) {
  return (
    <Box
      component={m.div}
      variants={varContainer()}
      initial={action ? false : 'initial'}
      animate={action ? (animate ? 'animate' : 'exit') : 'animate'}
      exit={action ? undefined : 'exit'}
      sx={sx}
      {...other}
    >
      {children}
    </Box>
  );
}
